module.exports = __webpack_public_path__ + "img/1241.675ed6e3.gif";